import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import {
  HttpClient, HttpHeaders
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';



@Injectable({
  providedIn: `root`,
})
export class ApiService {

  // private apiRoot: string;
  // public results: any[];
  // public path: string;
  // public loading: boolean;
  // public appId: string;
  /// * discuss and refactor this class */
  //const c = new CookieService();
  //constructor(private cookieService: CookieService) {  
  // }

  //#region static Api Helper

  //private static httpOptions = {
  //  headers: new HttpHeaders({
  //    'Content-Type': 'application/json',

  //  }), withCredentials: true
  //};

  public static genericObservablePost = (
    http: HttpClient,
    apiEndPoint: string,
    data: any
  ) => {
    const apiURL = environment.apiUrl + apiEndPoint;
    const token = localStorage.getItem('user_token');
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }), withCredentials: true
    };
    if (token) {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }), withCredentials: true
      };
    }
    return http.post(apiURL, data, httpOptions) as Observable<any>;
  }
  public static genericObservableGet = (
    http: HttpClient,
    apiEndPoint: string,
  ) => {
    const apiURL = environment.apiUrl + apiEndPoint;
    const token = localStorage.getItem('user_token');
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }), withCredentials: true
    };
    if (token) {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }), withCredentials: true
      };
    }
    return http.get(apiURL, httpOptions) as Observable<any>;
  }
  public static genericObservablePostWithOptions = (
    http: HttpClient,
    apiEndPoint: string,
    data: any,
    options?: {
      headers?: HttpHeaders | { [name: string]: string | string[] };
      responseType?: 'json' | 'blob' | 'arraybuffer' | 'text';
      observe?: 'body' | 'response';
      withCredentials?: boolean;
    }
  ): Observable<any> => {
    const apiURL = environment.apiUrl + apiEndPoint;
    const token = localStorage.getItem('user_token');

    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }

    if (options && options.headers) {
      if (options.headers instanceof HttpHeaders) {
        headers = options.headers;
        if (token && !headers.has('Authorization')) {
          headers = headers.set('Authorization', `Bearer ${token}`);
        }
      } else {
        const hdrObj = options.headers;
        for (const key in hdrObj) {
          if (Object.prototype.hasOwnProperty.call(hdrObj, key)) {
            const value = hdrObj[key];
            headers = headers.set(key, value as any);
          }
        }
      }
    }

    let withCreds = true;
    if (options && typeof options.withCredentials !== 'undefined') {
      withCreds = options.withCredentials as boolean;
    }

    let responseTypeAny: any = 'json';
    if (options && options.responseType) {
      responseTypeAny = options.responseType;
    }

    let observeAny: any = 'body';
    if (options && options.observe) {
      observeAny = options.observe;
    }

    const httpOptions: any = {
      headers: headers,
      withCredentials: withCreds,
      responseType: responseTypeAny,
      observe: observeAny
    };

    return http.post(apiURL, data, httpOptions) as Observable<any>;
  };
  
  //todo: Temp Soln. Need to remove
  public static genericJSONGet = (
    http: HttpClient,
  ) => {

    return http.get("./assets/masterdata.json") as Observable<any>;
  }


  public static genericObservablePostFormData = (
    http: HttpClient,
    apiEndPoint: string,
    data: any, formData: any
  ) => {
    const apiURL = environment.apiUrl + apiEndPoint;

    return http.post(apiURL, formData, { params: data }) as Observable<any>;
  }
  public static genericObservableGetKd(
    http: HttpClient,
    apiEndPoint: string
  ) {
    return this.genericObservableGet(http, apiEndPoint);
  }

  public static genericObservablePostKd(
    http: HttpClient,
    apiEndPoint: string,
    data: any
  ) {
    return this.genericObservablePost(http, apiEndPoint, data);
  }

  //#endregion


}
